import { render } from "./DynamicContent.vue?vue&type=template&id=acd7c3f6&ts=true"
import script from "./DynamicContent.vue?vue&type=script&lang=ts"
export * from "./DynamicContent.vue?vue&type=script&lang=ts"

import "./DynamicContent.vue?vue&type=style&index=0&id=acd7c3f6&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__